import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import bgImage from '@pkg/assets/images/dashboard-sidepanel-bg.png';
import { Button } from '@pkg/components/Sections/Profile/Buttons';

export const TwitterPromptWrapper = styled(motion.div)<{ $isMobile: boolean }>`
    display: flex;
    flex-direction: column;

    padding: 15px;
    position: absolute;
    background: linear-gradient(116.56deg, #523df0 0%, #4b4092 101.94%);
    border-radius: 8px;
    width: 227px;

    top: 66px;
    right: 2px;
    box-sizing: border-box;
    text-align: left;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 274px;
        padding: 20px;
    }

    ${({ $isMobile }) =>
        $isMobile &&
        css`
            position: fixed;
            top: unset;
            bottom: 56px;
            right: 28px;
            z-index: 40;

            @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                display: none;
            }
        `}
`;

export const MobileWrapper = styled(motion.div)`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    overscroll-behavior-y: contain;
    z-index: 1000;
    background-color: #0b0b0c;
    padding: 15px;

    background-image: url(${bgImage});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-attachment: fixed;
`;

export const PromptHeading = styled.h3`
    font-family: 'Alliance No.1';
    font-weight: 700;

    font-size: 20px;
    line-height: 21px;
    letter-spacing: -0.02em;

    color: #ffffff;
    margin: 0;
    padding: 0;
    margin-bottom: 10px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 24px;
        line-height: 25px;
        letter-spacing: -0.02em;
    }
`;

export const PromptSubheading = styled.h4`
    box-sizing: border-box;
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 400;

    font-size: 14px;
    line-height: 17px;
    letter-spacing: -0.03em;

    color: #ffffff;
    margin: 0;
    padding: 0;
    margin-bottom: 20px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 16px;
        line-height: 19px;
        letter-spacing: -0.03em;
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0;
    padding: 0;
`;

export const TextButton = styled.p`
    font-family: 'Alliance No.1';
    font-weight: 700;

    font-size: 12px;
    line-height: 12px;
    letter-spacing: -0.02em;

    color: #ffffff;
    margin: 0;
    padding: 0;
    cursor: pointer;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 14px;
        line-height: 14px;
        letter-spacing: -0.02em;
    }
`;

export const PromptArrow = styled.div<{ $isMobile: boolean }>`
    top: -5px;
    right: 12px;
    width: 11px;
    height: 11px;
    transform: rotate(45deg);
    position: absolute;
    background-color: #4d3faf;

    ${({ $isMobile }) =>
        $isMobile &&
        css`
            background-color: #4b4097;
            top: unset;
            bottom: -5px;
            right: 14px;
        `}
`;

export const SideSheetInner = styled(motion.div)`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const ConnectHeading = styled.h3`
    color: ${({ theme }) => theme.colors.white};
    font-family: 'Alliance No.1';
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: -0.03em;
    line-height: 120%;
    margin: 30px 20px 10px 20px;
    text-align: center;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 24px;
        line-height: 105%;
        letter-spacing: -0.02em;
        margin: 30px 0 10px 0;
    }
`;

export const ConnectSubheading = styled.h4`
    color: ${({ theme }) => theme.shades.white[50]};
    font-family: 'Alliance No.1';
    font-style: normal;
    margin: 0;
    text-align: center;
    font-weight: 500;
    font-size: 18px;
    line-height: 110%;
    text-align: center;
    letter-spacing: -0.03em;
    max-width: 420px;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 16px;
        line-height: 120%;
        margin: 0 20px;
    }
`;

export const ConnectModalWrapper = styled.div`
    .yat-modal-side-sheet__close {
        height: 60px;
        width: 60px;
        svg {
            width: 18px;
            height: 18px;
        }
    }
    .yat-modal-side-sheet {
        padding: 20px;
        z-index: 13;
        .yat-modal-side-sheet__sheet {
            padding: 10px;
            width: min(540px, 100%);
        }
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        .yat-modal-side-sheet {
            padding: 0;
        }
    }
`;

export const CtaButton = styled(Button)`
    width: 420px !important;
    margin: 60px 0 120px 0 !important;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 330px !important;
        margin: 50px 0 120px 0 !important;
    }
`;

export const StyledCtaButton = styled(CtaButton)`
    margin: 60px 0 0 0 !important;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin: 50px 0 0 0 !important;
    }
`;

export const GoBackText = styled.p`
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 100%;
    text-align: center;
    letter-spacing: -0.02em;
    padding: 0;
    margin: 30px 0 50px 0;
    cursor: pointer;
    opacity: 0.5;
    transition: opacity 0.1s ease;
    &:hover {
        opacity: 0.7;
    }
`;

export const CircleButton = styled.button`
    position: absolute;
    top: 0;
    left: 20px;
    height: 60px;
    width: 60px;
    border: 2px solid transparent;
    border-color: rgba(255, 255, 255, 0.15);
    background-color: transparent;
    outline: none;
    border-radius: 50%;
    transition:
        border-color 0.35s ease,
        background-color 0.35s ease;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
        height: 18px;
        width: 18px;
        fill: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.white};
    }
    &:hover {
        border-color: transparent;
        background-color: rgba(255, 255, 255, 0.15);
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 40px;
        width: 40px;
        top: 12px;
        left: 25px;
    }
`;

export const CloseButton = styled(CircleButton)`
    top: 12px;
    right: 25px;
    left: unset;
`;

export const MobileHeader = styled.h3`
    top: 25px;
    left: 50%;
    transform: translate(-50%, 0);
    position: absolute;
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 100%;
    text-align: center;
    display: inline-block;
    letter-spacing: -0.02em;
    margin: 0;
    padding: 0;
`;
